import React from "react";
import { Button } from "antd";
import GeneralBloc from "../../../bloc/general_bloc";

class AppTransparentButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  propButtonWidth() {
    return this.props.buttonWidth;
  }

  propButtonWidth() { return this.props.buttonWidth};

  render() {
    return (
      <Button
        onClick={(e) => this.props.onClick(e)}
        style={{
          backgroundColor: "#FFFFFF",
          color: "#EE7623",
          height: "44px",
          fontSize: "14px",
          paddingLeft: "30px",
          paddingRight: "30px",
          fontWeight: '600',
          width: this.propButtonWidth() || "",
          border: !this.props.borderedLess
            ? this.props.enable
              ? `1px solid #DA291C`
              : `1px solid #808EA8`
            : `0px solid #808EA8`,          
        }}
      >
        {" "}
        {this.props.label}
        {this.props.icon && (
          <span className="ml-2">
            {/* <img
              src={
                GeneralBloc.getAssetsContextPath() +
                `/assets/icons/LeftArrowWhite.svg`
              }
              alt="New"
              className="mr-2"
            /> */}
          </span>
        )}
      </Button>
    );
  }
}

export default AppTransparentButton;
